export function validateErrToString(errors){
    let message = '';
    for (let prop in errors) {
      message += `${prop}: `;
      if(Array.isArray(errors[prop])){
        for(let err of errors[prop]){
          message += err + "\n";
        }
      }
    }
    return message;
}